const BASE_URL = 'benefits'

export default {
  GET_BENEFITS: `/${BASE_URL}`,
  GET_BENEFIT: `/${BASE_URL}`,
}
